module App.Interfaces {
    export interface IDate {
        date: any;
        available: number;
        discount: number;
    }
}